import React from "react";
import styles from "../styles/ProductOverview.module.css";
import QuickViewCard from "./QuickViewCard";
import { getYearsOfExperience } from "../utils/experience";

const products = [
  {
    icon: "/images/note-ninja-icon.png",
    title: "Note Ninja",
    description: "Learn notes faster with bit-sized practice.",
    features: [
      "Quick daily exercises",
      "Clear feedback and progress",
      "Designed for real practice",
    ],
    image: "/images/note-ninja-preview.png",
    variant: "music",
    href: "/products#note-ninja",
    accent: "var(--music-500)",
  },
  {
    icon: "/images/record-health-icon.png",
    title: "Record Health",
    description: "Score and improve Salesforce data.",
    features: [
      "Define quality rules",
      "Automatic record scoring",
      "Identify missing data",
    ],
    image: "/images/record-health-preview.png",
    variant: "data",
    href: "/products#record-health",
    accent: "var(--data-500)",
  },
];

export default function ProductOverview() {
  return (
    <section className={styles.section} id="products">
      <div className={styles.inner}>
        <div className={styles.grid}>
          {products.map((product) => (
            <QuickViewCard key={product.title} content={product} />
          ))}
        </div>

        <div className={styles.trustStrip} aria-label="Credibility">
          <span>Salesforce Developer</span>
          <span className={styles.dot}>•</span>
          <span>React &amp; React Native</span>
          <span className={styles.dot}>•</span>
          <span>{getYearsOfExperience()}+ Years Experience</span>
          <span className={styles.dot}>•</span>
          <span>Salesforce Certified</span>
        </div>
      </div>
    </section>
  );
}
